exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inlet-wrapp ow-input-account-number input {\n    letter-spacing: 3px;\n}\n.inlet-wrapp ow-input-birth-number input {\n  letter-spacing: 3px;\n}\n", ""]);

// exports
